// Thank's IE8 for his funny defineProperty
module.exports = !require('./$.fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.descriptors.js
 ** module id = 17
 ** module chunks = 0
 **/